<script>
  import GallerySeriesAlbum from 'src/pc/pages/GallerySeriesAlbum'
  import PageLayout from '../layouts/PageLayout'
	export default {
    extends: GallerySeriesAlbum,
    components: {
      PageLayout,
    },
    computed: {
      getAccess () {
        return 'mobile'
      }
    }
  }
</script>

<style>
	.gallery_album {
    top: 0 !important;
  }
  .gallery_album .title {
    width: 100vw;
    height: 100px;
    margin-bottom: 30px !important;
  }
  .gallery_album .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .gallery_album .title_top:before {
    width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .gallery_album .title_top p {
    font-size: 34px;
  }
	.gallery_album .gallery_sch {
		text-align: left;
	}
	.gallery_album .gallery_sch h3 {
		width: 100%;
		font-size: 18px;
		line-height: 1.4em;
		margin-bottom: 10px;
	}
	.gallery_album .gallery_sch h3 em {
		font-size: 10px;
		padding: 0 10px;
	}
	.gallery_album .gallery_sch .sch_box {
    position: relative;
		width: 100%;
	}
	.gallery_album .gallery_sch .sch_box input {
		width: calc(100% - 136px);
		font-size: 14px;
	}
	.gallery_album .gallery_sch .sch_btn {
		width: 70px;
		font-size: 13px;
		line-height: 38px;
		padding: 0;
	}
	.gallery_album .gallery_sch .reset {
		width: 60px;
		font-size: 13px;
		line-height: 38px;
		padding: 0;
	}
  .gallery_album .list_gallery {
    width: 100vw;
		margin-left: -15px;
  }
  .gallery_album .list_gallery ul {
    grid-template-columns: repeat(auto-fill, minmax(25vw, 1fr));
    grid-gap: 2px;
    grid-auto-rows: minmax(33.3vw, auto);
  }
  .gallery_album .list_gallery li:nth-child(3n+1),
  .gallery_album .list_gallery li:nth-child(4n+1) {
    grid-column-end: span 1;
    grid-row-end: span 1;
  }
  .gallery_album .list_gallery li:nth-child(4n+1) {
    grid-column-end: span 2;
    grid-row-end: span 2;
  }
  .q-dialog .gallery_pop .close_btn {
    width: 50px;
		height: 50px;
		top: 5px;
		right: 5px;
  }
  .q-dialog .gallery_pop .album_ctnr .img img {
    max-width: 100vw;
		max-height: 120vh;
  }
  .q-dialog .gallery_pop .album_ctnr .article {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
    text-align: left;
		background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1.0) 75%);
		padding: 50px 10px 15px 10px;
		box-sizing: border-box;
  }
  .q-dialog .gallery_pop .album_ctnr .article p {
    width: 80vw;
  }
  .q-dialog .gallery_pop .album_ctnr .article .subj {
    font-size: 16px;
  }
  .q-dialog .gallery_pop .album_ctnr .article .tag a {
		font-size: 13px;
    font-weight: 200;
  }
  .q-dialog .gallery_pop .album_ctnr .article .series {
		font-size: 13px;
  }
  .q-dialog .gallery_pop .album_ctnr .img .img_wrap .download {
		position: fixed;
		right: 10px;
		bottom: 15px;
		margin: 0;
		background-size: 40%;
		z-index: 3;
  }
</style>
